import React, { useState, useEffect } from "react";
import "../asstes/main.css";
import axios from "axios";
import moment from "moment-timezone";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import { BsMusicNoteList } from "react-icons/bs";
import { BrowserRouter, useLocation } from "react-router-dom";
export default function AudioPlayers(props) {
console.log("props---", props)
  const location = useLocation();
  const day = moment().tz("America/Detroit").format("dddd");
  const time = moment().tz("America/Detroit").format("HH:mm");
  const [LiveAudio, setLiveAudio] = useState([]);
  const [LiveContent, setLiveContent] = useState([]);
  const [LiveShow, setLiveShow] = useState([]);
  const [LiveShowsData, setLiveShowsData] = useState([]);
  const [ShowTimeData, setShowTimeData] = useState([]);
  const [waveClass, setwaveClass] = useState("box");
  const [audioStatus, setaudioStatus] = useState(false);
  const [displaystatus, setdisplaystatus] = useState("none");
  useEffect(() => {
    axios
      .post(`https://app.soundchatradio.com:3000/api/v1/auth/listlivecontent`)
      .then((response) => {
        setLiveAudio(response.data.data[1]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    // props.locationChange(window.location.pathname)
    localStorage.setItem("locationpath", location.pathname);
    props.props(location.pathname);
    // console.log("location----", props.props(location.pathname))
    // window.location.reload(true)
  }, [location.pathname]);
 


  useEffect(() => {
    axios
      .post(`https://app.soundchatradio.com:3000/api/v1/auth/listshowschedule`)
      .then((response) => {
        setLiveShow(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    for (let i = 0; i < LiveShow.length; i++) {
      if (LiveShow[i].post_title === day) {
        setLiveShowsData(LiveShow[i].scheduleperdays);
        for (let j = 0; j < LiveShow[i].scheduleperdays.length; j++) {
          let starttime =
            LiveShow[i].scheduleperdays[j].show_start_date.split(":");
          let endtime = LiveShow[i].scheduleperdays[j].show_end_date.split(":");
          let currenttime = time.split(":");
         // console.log(starttime[0], endtime[0], currenttime[0], time, "sdghfg");
          if (
            parseInt(starttime[0]) <= parseInt(currenttime[0]) &&
            parseInt(endtime[0]) >= parseInt(currenttime[0])
          ) {
            //console.log("okay");
            setShowTimeData({
              show_name: LiveShow[i].scheduleperdays[j].show_name,
              show_audio_url: LiveShow[i].scheduleperdays[j].show_audio_url,
              show_image: LiveShow[i].scheduleperdays[j].show_image,
              show_start_date: LiveShow[i].scheduleperdays[j].show_start_date,
              show_end_date: LiveShow[i].scheduleperdays[j].show_end_date,
            });
          }
        }
      }
    }
  }, [LiveShow]);

  return (
    <>
      {(location.pathname === "/") ? (<>
          {/* <div className="header-top">
            <div className="header-top-wrapper d-flex">
              
              <div className="header-section-tow">
                <div className="d-flex right-div-section">
                  <div className="logo-soundchat">
                    <img
                      src={
                        "https://app.soundchatradio.com/soundradiobackend/images/podcast/" +
                        ShowTimeData.show_image
                      }
                      alt="img-error"
                    />
                  </div>
                  <div className="logo-text-heading">
                    <h6 className="header-new-bottom-new">
                      {ShowTimeData.show_name}
                    </h6>
                    <div className="top-head-section">
                      <p>{day}</p>
                      <p className="todu">
                        {ShowTimeData.show_start_date }
                          -
                         {ShowTimeData.show_end_date }
                      </p>
                    </div>

                    
                      <AudioPlayer
                        src={LiveAudio.livelink}
                        autoPlay={Boolean(audioStatus)}
                        customAdditionalControls={[]}
                        customVolumeControls={[]}
                        showJumpControls={false}
                        showFilledProgress={false}
                        onPause={(e) => {
                          console.log("onPause");
                          //  props.callback("pause");
                          localStorage.setItem("audioplayer", false);
                          localStorage.setItem("videoplayer", true);
                          if (waveClass === "box active") {
                            setwaveClass("box");
                          }
                        }}
                        onPlay={(e) => {
                          //  props.callback("play");
                          console.log("onPlay");
                          localStorage.setItem("audioplayer", true);
                          localStorage.setItem("videoplayer", false);
                          if (waveClass === "box") {
                            setwaveClass("box active");
                          }
                        }}
                      />
                      <div className="box-container flex">
                        <div className={`${waveClass} box1`}></div>
                        <div className={`${waveClass} box2`}></div>
                        <div className={`${waveClass} box3`}></div>
                        <div className={`${waveClass} box4`}></div>
                        <div className={`${waveClass} box5`}></div>
                        <div className={`${waveClass} box6`}></div>
                        <div className={`${waveClass} box7`}></div>
                        <div className={`${waveClass} box2`}></div>
                        <div className={`${waveClass} box3`}></div>
                        <div className={`${waveClass} box4`}></div>
                        <div className={`${waveClass} box5`}></div>
                        <div className={`${waveClass} box6`}></div>
                        <div className={`${waveClass} box7`}></div>
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      ) : (
        <>
          {/* <div
            className="audio-bar"
            onClick={() => {
              if (displaystatus === "none") {
                setdisplaystatus("");
              } else {
                setdisplaystatus("none");
              }
            }}
          >
            <div
              className="audio_start"
              style={{
                borderBottomLeftRadius:
                  displaystatus === "none" ? "50px" : "0px",
                borderBottomRightRadius:
                  displaystatus === "none" ? "50px" : "0px",
              }}
            >
              <div className="audio_start1" style={{ display: displaystatus }}>
                <div className="header-top">
                  <div className="header-top-wrapper-bottom d-flex">
                  
                    <div className="header-section-bottom">
                      <div className="d-flex right-div-section-bottom">
                        <div className="logo-soundchat">
                          <img
                            src={
                              "https://app.soundchatradio.com/soundradiobackend/images/podcast/" +
                              ShowTimeData.show_image
                            }
                            alt="img-error"
                          />
                        </div>
                        <div className="logo-text-heading">
                          <h6 className="header-new-bottom-new">
                            {ShowTimeData.show_name}
                          </h6>
                          <div className="top-head-section">
                            <p>{day}</p>
                            <p className="todu">
                              {ShowTimeData.show_start_date} -{" "}
                              {ShowTimeData.show_end_date}
                            </p>
                          </div>
                          <div className="">
                            <AudioPlayer
                              src={LiveAudio.livelink}
                              autoPlay={Boolean(audioStatus)}
                              customAdditionalControls={[]}
                              customVolumeControls={[]}
                              showJumpControls={false}
                              showFilledProgress={false}
                              onPause={(e) => {
                                console.log("onPause");
                                // props.callback("pause");
                                localStorage.setItem("audioplayer", false);
                                localStorage.setItem("videoplayer", true);
                                if (waveClass === "box active") {
                                  setwaveClass("box");
                                }
                              }}
                              onPlay={(e) => {
                                // props.callback("play");
                                localStorage.setItem("audioplayer", true);
                                localStorage.setItem("videoplayer", false);
                                console.log("onPlay");
                                if (waveClass === "box") {
                                  setwaveClass("box active");
                                }
                              }}
                            />
                            <div className="box-container flex">
                              <div className={`${waveClass} box1`}></div>
                              <div className={`${waveClass} box2`}></div>
                              <div className={`${waveClass} box3`}></div>
                              <div className={`${waveClass} box4`}></div>
                              <div className={`${waveClass} box5`}></div>
                              <div className={`${waveClass} box6`}></div>
                              <div className={`${waveClass} box7`}></div>
                              <div className={`${waveClass} box2`}></div>
                              <div className={`${waveClass} box3`}></div>
                              <div className={`${waveClass} box4`}></div>
                              <div className={`${waveClass} box5`}></div>
                              <div className={`${waveClass} box6`}></div>
                              <div className={`${waveClass} box7`}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <BsMusicNoteList />
            </div>
          </div> */}
        </>
      )}
    </>
  );
}
